import * as yup from "yup";

const validation = (messages) => {
  return yup.object().shape({
    fields: yup.object().shape({
      acceptTerms: yup.boolean().oneOf([true], " "),
      honorDeclaration: yup.boolean().oneOf([true], " "),
      // digitalConsent: yup.boolean().oneOf([true], " "),
      // earlyExecConsent: yup.boolean().oneOf([true], " "),
      // acceptNotice: yup.boolean().oneOf([true], " "),
      // acceptTeletransmission: yup.boolean().oneOf([true], " "),
      // acceptAgreement: yup.boolean().oneOf([true], " "),
    }),
  });
};

export default validation;
